// src/app/utils/app-initializer.ts

import { AuthService } from "src/app/pages/auth";


export function appInitializer(authService: AuthService): () => Promise<void> {
  return () =>
    new Promise<void>((resolve) => {
      authService.getUserByToken().subscribe({
        next: () => resolve(),
        error: () => resolve(),
        complete: () => resolve(),
      });
    });
}